type json = null | boolean | number | string | JsonArray | JsonObject;

interface JsonArray extends Array<json> {}

interface JsonObject {
  [key: string]: json;
}

interface ItemWithExpiration {
  value: json;
  until: number;
}

const A_DATE_MILLI = 24 * 60 * 60 * 1000;

/// localstorageに指定した時間まで有効期限として値を設定する
/// @param key localStorageのキー
/// @param value localStorageの値
/// @param validUntilDate 有効期限（指定した時間まで）
const setItemWithExpiration = (key: string, value: json, validUntilDate: Date) => {
  const itemWithExpirationToSave: ItemWithExpiration = {
    value: value,
    until: validUntilDate.getTime()
  };
  localStorage.setItem(key, JSON.stringify(itemWithExpirationToSave));
};

/// localstorageに指定した未来日数まで有効期限として値を設定する
/// @param key localStorageのキー
/// @param value localStorageの値
/// @param afterDate 有効期限（指定した未来日数）
const setItemAfterDates = (key: string, value: json, afterDate: number) => {
  setItemWithExpiration(key, value, new Date(Date.now() + afterDate * A_DATE_MILLI));
};

/// localstorageから有効期限のある値を取得する。
/// keyが存在しない、もしくは有効期限が切れた場合は、nullで返却する
/// また、有効期限切れた場合は、localStorageより削除する。
/// @param key localStorageのキー
/// @return 有効期限にあるキーの値、またはnull
const getItemWithExpiration = (key: string): json => {
  const item = localStorage.getItem(key);
  if (!item) {
    return null;
  }
  const itemWithExpiration: ItemWithExpiration = JSON.parse(item);
  if (!itemWithExpiration.until) {
    return null;
  }
  if (itemWithExpiration.until > Date.now()) {
    // valid key
    return itemWithExpiration.value;
  }

  // invalid, remove this key
  localStorage.removeItem(key);
  return null;
};

const StorageUtil = {
  setItemWithExpiration,
  setItemAfterDates,
  getItemWithExpiration
};

export default StorageUtil;
